import React from "react";
import { motion } from "framer-motion";
import { Column, HomeBox, MainHome } from "../Components/styled/Layout";
import earth from "../assets/images/javier-miranda-Jn2EaLLYZfY-unsplash.jpg";
import { Title, Subtitle } from "../Components/styled/Typo";
import { HomeButton } from "../Components/styled/Button";
import styled from "styled-components";
import { Fullscreen } from "../Components/styled/Image";

export default function Home() {
  return (
    <motion.div
      className="container"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 1, x: -100, transition: { duration: 0.1 } }}
    >
      <MainHome>
        <Fullscreen src={earth} />
        <HomeBox>
          <HomeColumn>
            <HomeTitle>NASA</HomeTitle>
            <HomeSubtitle>THE AMAZING STORY OF PARKER SOLAR PROBE</HomeSubtitle>
            <HomeButton to="/univers">Get Started</HomeButton>
          </HomeColumn>
        </HomeBox>
      </MainHome>
    </motion.div>
  );
}

const HomeTitle = styled(Title)`
  font-size: 8rem;
  text-align: center;
`;

const HomeSubtitle = styled(Subtitle)`
  font-size: 2rem;
  text-align: center;
  font-weight: 600;
`;

const HomeColumn = styled(Column)`
  justify-content: center;
  align-items: center;
`;

// // const Video = styled.video`
// //   width: 100%;
// //   height: 100%;
// //   object-fit: cover;
// //   object-position: right top;
// //   overflow: hidden;
// //   z-index: -1;
// // `;

// export default function Home() {
//   const videoRef = useRef();
//   const { t } = useTranslation();

//   useEffect(() => {
//     if (videoRef.current && !videoRef.current.playing) {
//       videoRef.current.play();
//     }
//   }, []);

//   return (
//     <Parent>
//       <Description>
//         <Title1>{t("nasa")}</Title1>
//         <Title2>{t("homeTitle")}</Title2>
//         <Button to="/univers">{t("getStarted")}</Button>
//       </Description>
//       {/* <Video
//         ref={(ref) => (videoRef.current = ref)}
//         muted={true}
//         controls={false}
//         autoPlay={true}
//         loop={true}
//         preload="auto"
//       >
//         <source src="video1.mp4" type="video/mp4" />
//       </Video> */}
//     </Parent>
//   );
// }
